<template>
  <el-card
    class="settings"
    shadow="never">
    <div
      slot="header"
      class="settings-header">
      自定义图片链接 <el-button
        type="danger"
        style="margin-left: 8px;"
        @click="deleteitem">删除</el-button>
    </div>
    <el-form
      ref="form"
      :model="slide"
      label-position="top"
      label-width="100px">
      <el-form-item
        label="布局："
        prop="layoutType">
        <el-radio-group v-model="slide.layoutType">
          <el-radio-button :label="1">一行一个</el-radio-button>
          <el-radio-button :label="2">一行二个</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="内容配置："
        prop="graphics">
        <el-dropdown>
          <el-button
            style="margin-bottom: 8px;"
            type="primary">
            添加<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu
            slot="dropdown">
            <el-dropdown-item
              @click.native="addMessages(1)">图片链接</el-dropdown-item>
            <el-dropdown-item
              @click.native="addMessages(2)">单图</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-table
          border
          :data="slide.graphics">
          <el-table-column
            label="首图"
            width="300"
            :resizable="false"
            prop="">
            <template slot-scope="{row, $index}">
              <!-- <el-form-item
                label-width="0"
                :prop="'graphics.'+$index + '.image'"
                :rules="[{ required: true, message: '请上传图片', trigger: 'change' }]"> -->
              <upload-with-crop
                v-model="slide.graphics[$index].image"
                :showTip="false"
                :limit="1"
                :isLt2M="512"
                :autoCropWidth="80"
                :autoCropHeight="80" />
              <!-- </el-form-item> -->
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            width="100"
            label="链接类型"
            prop="linkType">
            <template slot-scope="{row }">
              <!-- <el-form-item
                label-width="0"
                :prop="'graphics.'+$index + '.linkType'"
                :rules="[{ required: false, message: '请选择链接', trigger: 'change' }]"> -->
              {{ row.linkType | linkTypeName( row.contentType === 6 && row.linkType === 0 ? 6 : null ) }}
              <!-- </el-form-item> -->
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="链接内容"
            prop="title">
            <template slot-scope="{row}">
              <!-- <el-form-item label-width="0">  -->
              {{ row.title }}
              <!-- </el-form-item> -->
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="操作"
            width="105"
            prop="viewUserCount">
            <template slot-scope="{row, $index}">
              <!-- <el-button
                type="primary"
                @click="selectitem(row, $index)">选择链接</el-button> -->
              <el-dropdown>
                <el-button
                  type="info">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu
                  slot="dropdown">
                  <el-dropdown-item
                    v-if="row.contentType !==6 && row.linkType !== 15"
                    @click.native="selectitem(row, $index)">选择链接</el-dropdown-item>
                  <el-dropdown-item
                    @click.native="deleterowitem($index)">删除</el-dropdown-item>
                  <!-- <el-dropdown-item
                    @click.native="deleterowlink($index)">清空链接</el-dropdown-item> -->
                  <!-- <el-dropdown-item
                    v-if="row.contentType === 6"
                    @click.native="selectVideo(row, $index)">选择视频</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-alert
        title="只能上传image/*文件，且不超过500kb，建议上传相同宽高比的图片文件。"
        :closable="false"
        type="warning">
      </el-alert>
    </el-form>
    <content-select-modal
      ref="select"
      @handleSelect="handleSelect" />

    <!-- <select-message-modal
      ref="selectVideo"
      @select="handleSelectVideo" /> -->
  </el-card>
</template>

<script>
// import _ from 'lodash'
import { mapState } from 'vuex'
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import ContentSelectModal from '../content-select-modal.vue'
// import SelectMessageModal from '../select-message-modal.vue'
// const MAX_LENGTH = 5
export default {
  name: 'WeImage',
  components: { UploadWithCrop, ContentSelectModal }, // draggable, ContentCard
  props: {
    value: {
      type: Object,
      default() {
        return { componentName: 'pictureadv', layoutType: 1, graphics: [], visible: false }
      }
    },
    index: Number
  },
  data() {
    return {
      visible: false,
      currentIndex: -1,
      dragOptions: { animation: 0, disabled: false, group: 'description', ghostClass: 'ghost' }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    slide: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    deleterowitem(index) {
      this.slide.graphics.splice(index, 1)
    },
    // deleterowlink(index) {
    //   this.$set(this.slide.graphics, index, {
    //     ...this.slide.graphics[index],
    //     link: null,
    //     linkType: 15,
    //     title: '',
    //     contentType: null,
    //     content: null
    //   })
    // },
    selectitem(row, $index) {
      console.log(row, $index)
      this.$refs.select.init(row, $index)
    },
    // selectVideo(row, $index) {
    //   console.log(row, $index)
    //   this.currentIndex = $index
    //   this.$refs.selectVideo.fetch()
    // },
    // handleSelectVideo(row) {
    //   console.log(row)
    //   this.$set(this.slide.graphics, this.currentIndex, {
    //     ...this.slide.graphics[this.currentIndex],
    //     ...row,
    //     image: row.content
    //   })
    //   this.currentIndex = -1
    // },
    handleSelect(info, index) {
      this.$set(this.slide.graphics, index, { ...this.slide.graphics[index], ...info })
    },
    addMessages(type) {
      if (type === 1) {
        this.slide.graphics.push({ title: '', image: [], linkType: null, link: null })
      }
      if (type === 2) {
        this.slide.graphics.push({ title: '', image: [], linkType: 15, link: null })
      }
      // if (type === 3) {
      //   this.slide.graphics.push({ title: '', image: '', linkType: 0, contentType: 6, link: null })
      // }
    },
    submit() {
      return new Promise((resolve, reject) => {
        const graphics = this.slide.graphics
        if (graphics.length === 0 || graphics.some(i => i.image.length === 0 || i.linkType == null)) {
          this.$message.error('请填写完整的信息')
          reject(new Error(JSON.stringify({ index: this.index })))
        } else {
          resolve()
        }
        // this.$refs.form.validate(v => {
        //   if (v) {
        //     resolve()
        //   } else {
        //     reject(new Error(JSON.stringify({ index: this.index })))
        //   }
        // })
      })
    }
  }
}
</script>
